import Api, { HealthCenter, Unit, UnitVisibilityOption } from '@silbo/core';

export const getUnitsQuery = (
  visibilityConfig: UnitVisibilityOption,
  healthCenter: HealthCenter | undefined,
  unitIds: string[]
) => {
  const query = new Api.Query(Unit)
    .equalTo(`visibilityConfig.${visibilityConfig}`, true)
    .equalTo('healthCenter', healthCenter);

  if (unitIds.length > 0) {
    query.containedIn('objectId', unitIds);
  }
  return query;
};
